import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-support',
  templateUrl: './support-widget.component.html'
})

export class SupportWidgetComponent {
}
